module.exports = __webpack_public_path__ + "static/img/logo10.5468ae3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/logo10.png
// module id = rZGW
// module chunks = 1